import React from 'react';
import { Card, Container} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import logo from '../Assets/logo.png';


export default function EmployeeResetNotification(){
    return (
        <>
            <Container className="d-flex align-items-center justify-content-center mt-5" style={{minHeight: "60vh"}}>
                <div className="w-100" style={{maxWidth: "600px"}}>
                    <Card>
                        <Card.Img variant="top" src={logo} style={{width:"50%", alignSelf:"center", paddingTop:"20px"}}/>
                        <Card.Body>
                            <h2 className="text-center mb-4">Password Reset Notification</h2>
                            <h5>
                                An email has been sent to you with a password reset link.
                            </h5>
                            <h6>Don't forget to check your spam folder if you don't see the email.</h6>
                        </Card.Body>
                    </Card>
                    <div className="w-100 text-center mt-2">
                        Return to <Link to="/employee-login">Log_in</Link>
                    </div>
                </div>
            </Container>
        </>
    );
}